module.exports = __webpack_public_path__ + "img/14.b14d5c01.jpg";